var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"no-padding bottom-padding",attrs:{"fluid":""}},[_c('canvas',{ref:"drawdownCanvas",attrs:{"renderingKey":_vm.renderingKey,"width":_vm.canvasWidth,"height":_vm.canvasHeight}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dd4d7c1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroundWeaveDrawdown.vue
// module id = null
// module chunks = 